import jwt from "jsonwebtoken";
import bcrypt from "bcryptjs"

const JWT_PRIVATE_KEY="6GmFLUuWtZJURhnJ94KeBP36RB8Ci8H5"

export const decodedToken = ({ token }) => {
 
  return jwt.verify(
    token,
    JWT_PRIVATE_KEY,
    function (err, decoded) {
      if (err) {
        return null;
      }
      
      return decoded;
    }
  );
};

export const HashingPassword = async (password) => {
  
  return jwt.sign( {password} , JWT_PRIVATE_KEY, {
    algorithm: "HS256",
  });
  
};

export const hashPassword = (password) => {
  const hash = bcrypt.hashSync(password, 12);
  return hash;
};

export const comparePassword = (newPassword, hashPassword) => {
  const check = bcrypt.compareSync(newPassword, hashPassword);
  return check;
};